export default __webpack_public_path__ + "static/aviation-717d22ba9853c952903cd2a770815a9d.jpeg";